import { MIDDLEWARE } from "../constants/api";

export const extractDomain = () => {
  let domain = "";
  const url = window.location.origin;
  if (url.includes("localhost" || "test")) {
    domain = "https://recruiter.foundit.in";
  } else {
    domain = window.location.origin;
  }
  return domain;
};

export function callFromMiddleware(url: string): string {
  return `${MIDDLEWARE}${url}`;
}

interface SalaryItem {
  label: string;
  value: number;
}

type SalaryFieldList = () => SalaryItem[];
export const getMaxSalaryOption = (
  list: SalaryFieldList,
  value: number
): SalaryItem[] => {
  return list().filter((item) => item.value >= value);
};
export const salaryFieldList = () => {
  const salary = [];
  const label = "label";
  const value = "value";
  const crore = 10000000;
  const lakh = 100000;

  for (let i = 50000; i <= 15000000; i += 50000) {
    const itemLabel = `Rs ${i?.toLocaleString("en-IN")}`;
    let val;
    let item;

    if (i < 10000000) {
      val = i / lakh;
      item = ` (${val.toFixed(2)} lakhs per year)`;
    } else {
      val = i / crore;
      item = ` (${val.toFixed(2)} Cr per year)`;
    }

    const data = { [label]: itemLabel + item, [value]: i };
    salary.push(data);
  }

  return salary;
};

export const formatNumberWithCommas = (number: string, useStandard: boolean) => {
  if(!number){
    return ""
  }
  let formattedNumber = "";
  let initialNumber = number;
  if(initialNumber && (String(initialNumber)?.includes(',') || String(initialNumber)?.includes('₹'))){
    initialNumber = removeCommas(initialNumber)
  }
 
  if (useStandard) {
    formattedNumber = String(initialNumber)?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    // Split number into two parts: the part that needs pairs and the last three digits
    let lastThreeDigits = String(initialNumber)?.slice(-3);
    let otherDigits = String(initialNumber)?.slice(0, -3);
 
    // Format the part before the last three digits with pairs
    if (otherDigits) {
      otherDigits = otherDigits?.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      formattedNumber = otherDigits + ',' + lastThreeDigits;
    } else {
      // If there are no other digits, just return the last three digits
      formattedNumber = lastThreeDigits;
    }
   
    // Add the rupee symbol
    formattedNumber = '₹' + formattedNumber;
  }
 
  return formattedNumber;
};
 
export const removeCommas = (numberWithCommas: string) => {
  return numberWithCommas?.replace(/,|₹/g, '');
};

export const getSalaryWitComma = (salary:any) => {
  let salary_ = Number(salary)
  if(salary && salary_ > 0){
    return salary_?.toLocaleString("en-IN")
  }else{
    return null
  }
}

//map in redux state as per BE
export function mapCategory(
  category: any,
  categoryId: string,
  categoryName: string,
  functionName:string,
) {
  // Initialize an array to store the mapped locations
  let mappedCategory: any[] = [];

  // Map the current locations
  category.forEach((category: any, index: any) => {
    let obj: any = {};
    obj[categoryId] = category.id;
    obj[categoryName] = category.name;
    obj[functionName] = category?.functionName
    mappedCategory.push(obj);
  });

  return mappedCategory;
}


export function mapSkills(
  category: any,
  categoryId: string,
  categoryName: string,
  categoryType?: string,
  categoryTypeValue?: string,
) {
  // Initialize an array to store the mapped locations
  let mappedCategory: any[] = [];
  // Map the current locations
  category.forEach((categoryItem: any, index: any) => {
    if(!categoryItem.label.trim()) return 
    let obj: any = {
      [categoryId]: 0,
      [categoryName]: categoryItem?.label,
    };

    if (categoryType !== undefined) {
      obj[categoryType] = categoryTypeValue || categoryItem?.type || 'A';
    }

    mappedCategory.push(obj);
  });

  return mappedCategory;
}

export const getHealthApiPayload = (status: number, queryObject: any, startTime: Date, recruiterId: any, pageName: string) => {
  let  HTMLresponseEnd = 0;
  let domInteractiveTime = 0;
  let serverResponseTime = 0;
  let endDate = Date.now();

  if (window.performance && window.performance.getEntriesByType) {
    const entries = window.performance.getEntriesByType('navigation');
    if (entries.length > 0) {
        const navTiming = entries[0] as PerformanceNavigationTiming;
        serverResponseTime =  navTiming.responseEnd - navTiming.requestStart;
        serverResponseTime = Math.round(((serverResponseTime / 1000) + Number.EPSILON) * 100) / 100;
        if (navTiming.loadEventEnd) {
            HTMLresponseEnd = navTiming.responseEnd
            domInteractiveTime = navTiming.domInteractive
        }
    }
}


  const timeDiff = (endDate - startTime.getTime())/1000;
  return {
    query: JSON.stringify(queryObject),
    pageStatus : status,
    pageLoadStartTime : `${new Date((window as any).startTime - HTMLresponseEnd)}`,
    pageLoadEndTime : `${new Date(endDate)}`,
    pageName: pageName,
    pageURL: window.location.href,
    subUID : recruiterId,
    pageLoadTime : timeDiff,
    timeOfInteraction: domInteractiveTime/1000,
    totalLoadTime: (endDate - ((window as any).startTime) + HTMLresponseEnd) / 1000,
    serverResponseTime: serverResponseTime
  }
 
}

export const getNextDate = (date:any) => {
  const nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    return nextDay;
}

export const processEmailString = (emailString:any) => {
  emailString = emailString?.trim();
  let emails = emailString?.split(',')
                          ?.map((email:any) => email.trim())
                          ?.filter((email:any) => email !== '');
  return emails?.join(',');
}

 interface Qualification {
  qualificationId: number;
  qualificationName: string;
  specializationId: number;
  specializationName: string;
}

export function replaceQualificationWithSpecialization(data: Qualification[],redux:boolean): Qualification[] {
  // Create a modified version of the data where qualificationName contains "All"
  const modifiedData = data?.map(item => {
      if (item?.qualificationName?.includes("All")) {
          return {
              specializationId: item?.specializationId,
              specializationName: item?.specializationName,
              qualificationId: item?.specializationId,
              qualificationName: item?.specializationName,
          };
      }
      return null; // Return null for items that don't match the condition
  }).filter(item => item !== null) as Qualification[]; // Filter out the null values
  // Combine the original data with the modified data
  return  [
      ...data,         // Original items
      ...modifiedData  // Modified items
  ]
}

export function includeTopEducationCluster(data: Qualification[], specialization: Specialization[]): Qualification[] {
  const newData = [...data]; // Create a copy of the data array
  const addedItems = new Set<string>();  // Create a set to track added items and prevent duplicates

  specialization?.forEach(parent => {
    if (parent?.children && parent?.name?.includes("All")) {
      parent?.children?.forEach(child => {
        data?.forEach(item => {
          if (item?.qualificationId === child?.id && !item?.qualificationName?.includes("All")) {
            
            // Create the new qualification object
            const newQualification: Qualification = {
              specializationId: item?.qualificationId,
              specializationName: item?.qualificationName,
              qualificationId: parent?.id,
              qualificationName: parent?.name,
            };

            // Generate a unique key for the new qualification object
            const uniqueKey = `${newQualification?.qualificationId}-${newQualification?.specializationId}`;

            // Add the new qualification to newData if it's not already added
            if (!addedItems?.has(uniqueKey)) {
              newData?.push(newQualification);
              addedItems?.add(uniqueKey); // Mark this unique key as added
            }
          }
        });
      });
    }
  });

  return newData; // Return the new array
}


interface Specialization {
  id: number;
  name: string;
  children?: Specialization[];
}

export function transformQualifications(qualifications: Qualification[] | any, specializations: Specialization[],redux:boolean): Qualification[] {
  // Create a map for quick access to specializations by qualificationId
  const specializationMap = new Map<number, Specialization[]>();

  specializations?.forEach(spec => {
      specializationMap.set(spec?.id, spec?.children || []);
  });
  const education = replaceQualificationWithSpecialization(qualifications,redux)
  // Flatten the qualifications data based on the specializations map
  return education?.flatMap(qualification => {
      const specializationList = specializationMap?.get(qualification?.qualificationId) || [];
      if (qualification?.qualificationId === qualification?.specializationId) {
      return specializationList?.map(child => ({
          specializationId: child?.id,
          specializationName: child?.name,
          qualificationId: qualification?.qualificationId,
          qualificationName: qualification?.qualificationName,
      }));
    }
    return {
      specializationId: qualification?.specializationId,
          specializationName: qualification?.specializationName,
          qualificationId: qualification?.qualificationId,
          qualificationName: qualification?.qualificationName,
    }
  });

}

export function extractBaseServer(url:string) {
  if (url.includes("localhost") || url.includes("test") ) {
    url = "recruiter.foundit.in";
  }
 
  const parts = url.split('.');
  const domain = parts[parts.length - 2] + '.' + parts[parts.length - 1];
 
  return domain;
}

export function convertDateFormat(date:Date){
const day = String(date.getDate()).padStart(2, '0');
const month = String(date.getMonth() + 1).padStart(2, '0');
const year = date.getFullYear();
const hours = date.getHours();
const minutes = date.getMinutes();
const seconds = date.getSeconds();
const formattedDate = `${day}/${month}/${year}`;
const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
return `${formattedDate} - ${formattedTime}`
}


export function isValidPhoneNumber(phone:any) {
  const cleanedPhone = phone?.replace(/[\s()-]/g, "");
  const phoneRegex = /^\+?[1-9]\d{1,14}$/;
  return phoneRegex.test(cleanedPhone);
}


export function getOwnerEmail(email:string){
  let ownerEmail = email?.split(',')?.[0] || email
  return ownerEmail
}

export const getDefaultValues = (jobformData: any, channelId:number) => {
  let roleList = jobformData?.roleList;
  let categoryList = jobformData?.categoryList;
  let nationalityList = jobformData?.nationalityList;
  if((!nationalityList || nationalityList?.length === 0 ) && channelId === 1 ){
    nationalityList = [
      {
      nationalityCode:"ISOIN",
      nationalityId:100,
      nationalityName:"Indian"
    }
  ]
  }
  if (roleList?.length === 0 && categoryList?.length === 0) {
    roleList = [{ roleId: 90, roleName: "Other Roles" }];
    categoryList = [{ categoryId: 15, categoryName: "Others" }];
  }

  return { roleList, categoryList, nationalityList };
};